<template>
  <div class="footContainer">
    <div class="foot clearfix">
      <div class="contactUs left">
        <p>电话: 4000-029-428</p>
        <p>邮箱: sxsbjxh@163.com</p>
        <p>投稿邮箱: dzyxjy@163.com</p>
        <p>地址: 陕西省西安市雁塔西路76号</p>
      </div>
      <div class="code right">
        <div class="allerma clearfix">
          <div class="ermasingle left">
            <p>
              <b>扫码使用医生协作</b>
            </p>
            <div class="codeImg">
              <img src="./../../assets/code3.jpg" />
            </div>
          </div>
          <div class="ermasingle left">
            <p>
              <b>扫码关注大众教育</b>
            </p>
            <div class="codeImg">
              <img src="./../../assets/code2.jpg" />
            </div>
          </div>
          <div class="ermasingle left">
            <p>
              <b>微信扫码关注学会</b>
            </p>
            <div class="codeImg">
              <img src="./../../assets/newcode.jpg" />
            </div>
          </div>
        </div>
      </div>
      <div style="clear: both"></div>
      <div class="copy">
        <div style="width: 390px; margin: 0 auto; padding: 20px 0; height: 65px">
          <span style="display: inline-block; margin-right: 10px"
            >Copyright 2003- {{ times }}</span
          ><span style="display: inline-block; margin-right: 10px"
            >陕西省保健学会版权所有</span
          ><a
            href="https://beian.miit.gov.cn"
            style="color: #eaf0eb; text-decoration: none"
            >陕ICP备18015315号</a
          >
        </div>
        <div style="width: 300px; margin: 0 auto; padding: 20px 0">
          <a
            target="_blank"
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=61011302000802"
            style="
              display: inline-block;
              text-decoration: none;
              height: 20px;
              line-height: 20px;
            "
            ><img src="./../../assets/copyIcon.png" style="float: left" />
            <p
              style="
                float: left;
                height: 20px;
                line-height: 20px;
                margin: 0px 0px 0px 5px;
                color: #ffffff;
              "
            >
              陕公网安备 61011302000802号
            </p></a
          >
        </div>
      </div>
    </div>

    <div class="toTop" title="回到顶部" @click="toTop">
      <img src="../../assets/top.png" />
    </div>
  </div>
</template>

<script>
export default {
  name: "footPart",
  data() {
    return {
      times: "2021",
    };
  },
  methods: {
    toTop: function () {
      var time = setInterval(function () {
        var e = document.documentElement.scrollTop || document.body.scrollTop;
        document.documentElement.scrollTop = document.body.scrollTop = e - 300;
        if (document.documentElement.scrollTop <= 0 && document.body.scrollTop <= 0) {
          document.documentElement.scrollTop = document.body.scrollTop = 0;
          clearInterval(time);
        }
      }, 10);
    },
  },
  mounted() {
    var newdata = new Date(),
      year = newdata.getFullYear();
    this.times = year;
  },
};
</script>

<style lang="less" scoped>
@base: #3e8f83;
@baseBase: #eaf0eb;
@pcWidth: 1230px;
@padWidth: 982px;
.footContainer {
  width: 100%;
  height: auto;
  background-color: @base;
}
.foot {
  height: 210px;
  width: @pcWidth;
  margin: 0px auto;
  padding: 30px 0px;
  box-sizing: content-box;
  overflow: hidden;
  color: #fff;
}
.code {
  width: 540px;
  height: 150px;
  .allerma {
    width: 100%;
    height: 180px;
  }
  .ermasingle {
    width: 180px;
    height: 150px;
  }
  p {
    margin-bottom: 0px;
    font-size: 12px;
    text-align: center;
    height: 20px;
    line-height: 20px;
  }
  .codeImg {
    width: 130px;
    height: 130px;
    margin: 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
.contactUs {
  p {
    margin-bottom: 10px;
    font-size: 12px;
    line-height: 30px;
  }
}
.copy {
  border-top: 1px solid #fff;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  div {
    font-size: 12px;
    line-height: 20px;
    padding: 20px 0;
  }
}
.toTop {
  width: 60px;
  height: 60px;
  border-radius: 10px;
  background-color: rgba(210, 210, 210, 1);
  position: fixed;
  bottom: 50px;
  right: 50px;
  cursor: pointer;
  color: #fff;
  text-align: center;
  line-height: 50px;
  font-size: 26px;
  overflow: hidden;
  img {
    width: 30px;
    height: 30px;
  }
}
@media screen and (max-width: 1260px) {
  .foot {
    width: @padWidth;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/footPart.vue